module.exports = __webpack_public_path__ + "img/wb6@2x.b7935dc6.png";